var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clinicList"},_vm._l((_vm.list),function(item,index){return _c('clinicItem',{key:index,staticClass:"clinic-item",attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }